import { createContext, useContext, useReducer, useState, useCallback, useEffect } from "react";
import { createClient } from "@supabase/supabase-js";

// ─── SUPABASE ─────────────────────────────────────────────────────────────────
const supabase = createClient(
  "https://hmgeuxrzfvtmakzgpqub.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhtZ2V1eHJ6ZnZ0bWFremdwcXViIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA2NDI5MTEsImV4cCI6MjA5NjIxODkxMX0.x47UKwapRRSm6npdNVptJ7WkN9rM5ntf-d9jkI2zWUc"
);

const SHEETS_URL = "https://script.google.com/macros/s/AKfycbyk5dFk5wzPxB1Bx02GqKKp2NPcR8GlCTVuub27WaOscYoHlCha52HhmsFhjh2bUzsbew/exec";

async function saveToSheet(data) {
  try {
    await fetch(SHEETS_URL, { method:"POST", mode:"no-cors", headers:{"Content-Type":"application/json"}, body:JSON.stringify(data) });
  } catch(e) { console.log("Sheet error:", e); }
}

export const WA = "918766584266";

export const CATEGORIES = ["Fabric","Western Wear","Kurti","3 Piece Set","Cord Set","Readymade Blouse","Dupatta","Bottom Wear"];

export const CAT_META = {
  "Fabric":            { emoji:"🪡", color:"#7C3AED", light:"#F3EEFF" },
  "Western Wear":      { emoji:"👚", color:"#0EA5E9", light:"#E0F2FE" },
  "Kurti":             { emoji:"👗", color:"#EC4899", light:"#FDF2F8" },
  "3 Piece Set":       { emoji:"✨", color:"#F59E0B", light:"#FFFBEB" },
  "Cord Set":          { emoji:"🌸", color:"#10B981", light:"#ECFDF5" },
  "Readymade Blouse":  { emoji:"💃", color:"#EF4444", light:"#FEF2F2" },
  "Dupatta":           { emoji:"🎀", color:"#8B5CF6", light:"#F5F3FF" },
  "Bottom Wear":       { emoji:"👖", color:"#06B6D4", light:"#ECFEFF" },
};

// Cosmetic list only (shown in Admin Panel → Staff tab). Real admin credentials
// live in Supabase Auth now — see the deploy notes for how to create/tag them.
export const ADMIN_USERS = [
  { email:"mis@ematchwell.com", name:"MIS Admin", role:"admin" },
  { email:"mdo@ematchwell.com", name:"MDO Admin", role:"admin" },
];

// ─── COUPONS ──────────────────────────────────────────────────────────────────
// Add/remove/edit coupon codes here. type: "percent" (of subtotal) or "flat" (₹ off).
// maxDiscount caps a percent coupon's rupee value (optional).
export const INIT_COUPONS = {
  "MATCHWELL10": { type:"percent", value:10, minOrder:999,  maxDiscount:300, label:"10% off", active:true },
  "WELCOME50":   { type:"flat",    value:50,  minOrder:499,  maxDiscount:null, label:"₹50 off", active:true },
  "FESTIVE200":  { type:"flat",    value:200, minOrder:1999, maxDiscount:null, label:"₹200 off", active:true },
};

export const INIT_PRODUCTS = [
  { id:1,  name:"Cotton Printed Kurti",    category:"Kurti",            price:1299, mrp:1800, stock:32, badge:"New",      description:"Hand-block printed cotton kurti.", material:"100% Cotton",  care:"Machine Wash",  colors:["Blue","Pink","Yellow","White"],       sizes:["S","M","L","XL","2XL","3XL"], img:"https://images.unsplash.com/photo-1583391733956-6c78276477e2?w=500&q=80", rating:4.6, reviews:89  },
  { id:2,  name:"Linen Cord Set",          category:"Cord Set",         price:1899, mrp:2400, stock:20, badge:"Hot",      description:"Pure linen top and pants.", material:"100% Linen", care:"Hand Wash", colors:["Sage","Beige","Dusty Rose"], sizes:["S","M","L","XL"], img:"https://images.unsplash.com/photo-1594938298603-c8148c4b4d25?w=500&q=80", rating:4.9, reviews:201 },
  { id:3,  name:"Chanderi Silk Fabric",    category:"Fabric",           price:499,  mrp:650,  stock:100,badge:"",         description:"Lightweight Chanderi silk.", material:"Chanderi", care:"Dry Clean", colors:["Gold","Maroon","Teal"], sizes:["Per Metre"], img:"https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=500&q=80", rating:4.5, reviews:45 },
  { id:4,  name:"Western Crop Top",        category:"Western Wear",     price:899,  mrp:1200, stock:40, badge:"Trending", description:"Stylish crop top.", material:"Poly Cotton", care:"Machine Wash", colors:["Black","White","Red"], sizes:["S","M","L","XL"], img:"https://images.unsplash.com/photo-1469334031218-e382a71b716b?w=500&q=80", rating:4.5, reviews:65 },
  { id:5,  name:"Embroidered 3 Piece Set", category:"3 Piece Set",      price:2999, mrp:3800, stock:12, badge:"Premium",  description:"Embroidered kurta, dupatta, salwar.", material:"Georgette", care:"Dry Clean", colors:["Pink","Blue","Green"], sizes:["S","M","L","XL","2XL"], img:"https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=500&q=80", rating:4.8, reviews:78 },
  { id:6,  name:"Designer Blouse",         category:"Readymade Blouse", price:799,  mrp:1100, stock:25, badge:"New",      description:"Ready-to-wear designer blouse.", material:"Silk Blend", care:"Hand Wash", colors:["Red","Green","Navy","Gold"], sizes:["32","34","36","38","40","42"], img:"https://images.unsplash.com/photo-1617019114583-affb34d1b3cd?w=500&q=80", rating:4.7, reviews:112 },
  { id:7,  name:"Chiffon Dupatta",         category:"Dupatta",          price:349,  mrp:500,  stock:60, badge:"",         description:"Light printed chiffon dupatta.", material:"Chiffon", care:"Gentle Wash", colors:["Multi","Red","Blue","Green"], sizes:["Free Size"], img:"https://images.unsplash.com/photo-1605763240000-7e93b172d754?w=500&q=80", rating:4.4, reviews:42 },
  { id:8,  name:"Palazzo Bottom Wear",     category:"Bottom Wear",      price:599,  mrp:800,  stock:45, badge:"Bestseller",description:"Flowy palazzo pants.", material:"Rayon", care:"Machine Wash", colors:["Black","Maroon","Navy","Beige"], sizes:["S","M","L","XL","2XL","3XL"], img:"https://images.unsplash.com/photo-1591369822096-ffd140ec948f?w=500&q=80", rating:4.6, reviews:134 },
  { id:9,  name:"Anarkali Kurti",          category:"Kurti",            price:1599, mrp:2200, stock:18, badge:"Trending", description:"Elegant floor-length anarkali.", material:"Rayon", care:"Machine Wash", colors:["Mustard","Teal","Wine","Maroon"], sizes:["S","M","L","XL","2XL"], img:"https://images.unsplash.com/photo-1583391733956-6c78276477e2?w=500&q=80&sat=-10", rating:4.7, reviews:156 },
  { id:10, name:"Straight Fit Kurti",      category:"Kurti",            price:999,  mrp:1400, stock:30, badge:"",         description:"Classic straight fit kurti.", material:"Cotton Blend", care:"Machine Wash", colors:["White","Light Blue","Mint"], sizes:["S","M","L","XL","2XL","3XL"], img:"https://images.unsplash.com/photo-1594938298603-c8148c4b4d25?w=500&q=80&sat=-10", rating:4.4, reviews:88 },
  { id:11, name:"Palazzo Kurti Set",       category:"Kurti",            price:1799, mrp:2400, stock:15, badge:"Hot",      description:"Kurti with matching palazzo.", material:"Rayon", care:"Machine Wash", colors:["Mustard","Navy","Coral"], sizes:["S","M","L","XL","2XL","3XL"], img:"https://images.unsplash.com/photo-1576185850227-1f72b7f8d483?w=500&q=80", rating:4.8, reviews:203 },
  { id:12, name:"Embroidered Kurti",       category:"Kurti",            price:1899, mrp:2600, stock:10, badge:"Premium",  description:"Heavily embroidered festive kurti.", material:"Georgette", care:"Dry Clean", colors:["Red","Royal Blue","Bottle Green"], sizes:["S","M","L","XL","2XL"], img:"https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=500&q=80&sat=10", rating:4.9, reviews:91 },
  { id:13, name:"Denim Shirt",             category:"Western Wear",     price:1199, mrp:1600, stock:20, badge:"",         description:"Classic denim shirt.", material:"Denim", care:"Machine Wash", colors:["Blue","Dark Blue"], sizes:["S","M","L","XL","2XL"], img:"https://images.unsplash.com/photo-1551537482-f2075a1d41f2?w=500&q=80", rating:4.3, reviews:48 },
  { id:14, name:"Silk Salwar",             category:"Bottom Wear",      price:699,  mrp:950,  stock:35, badge:"New",      description:"Soft silk salwar pants.", material:"Art Silk", care:"Hand Wash", colors:["Black","Beige","Ivory"], sizes:["S","M","L","XL","2XL","3XL"], img:"https://images.unsplash.com/photo-1591369822096-ffd140ec948f?w=500&q=80&hue=60", rating:4.5, reviews:67 },
  { id:15, name:"Cotton Fabric",           category:"Fabric",           price:199,  mrp:280,  stock:80, badge:"",         description:"Premium cotton fabric.", material:"Cotton", care:"Washable", colors:["White","Cream","Grey"], sizes:["Per Metre"], img:"https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=500&q=80&hue=30", rating:4.2, reviews:33 },
];

export const INIT_BANNERS = [
  { id:1, title:"Summer Collection 2025", subtitle:"Fresh linen & cotton arrivals", cta:"Shop Now", bg:"linear-gradient(135deg,#667eea,#764ba2)", img:"" },
  { id:2, title:"Festive Sarees & Sets",  subtitle:"Up to 40% off on premium collection", cta:"Explore", bg:"linear-gradient(135deg,#f093fb,#f5576c)", img:"" },
  { id:3, title:"New Cord Sets Arrived",  subtitle:"Trendy matching sets for every occasion", cta:"View All", bg:"linear-gradient(135deg,#4facfe,#00f2fe)", img:"" },
];

export const HOME_SECTIONS = [
  { key:"hero",           label:"Main Hero Banner (top slider)" },
  { key:"ticker",         label:"Offer Ticker (scrolling strip)" },
  { key:"catStrip",       label:"Category Strip / Our Collections" },
  { key:"featured",       label:"Featured by Matchwell" },
  { key:"kurtiStyle",     label:"Shop Kurtis by Style" },
  { key:"seasonalBanner", label:"Seasonal Banner (cream promo card)" },
  { key:"collections",    label:"Homepage Collections (New In, Trendy, etc.)" },
  { key:"priceWise",      label:"Price-Wise" },
  { key:"newArrivalRows", label:"New Arrivals (Ethnic/Western/Accessorize rows)" },
  { key:"occasion",       label:"Occasion Collections" },
  { key:"recentlyViewed", label:"Recently Viewed" },
  { key:"whatsappBanner", label:"WhatsApp Banner" },
  { key:"showroomMap",    label:"Showroom Map" },
  { key:"whyUs",          label:"Why Shop With Us" },
];
export const INIT_SECTION_VIS = Object.fromEntries(HOME_SECTIONS.map(s=>[s.key,true]));

export const VIDEO_ASPECTS = [
  { key:"portrait", label:"Portrait (4:5)", ratio:"4/5" },
  { key:"reel",     label:"Reel (9:16)",    ratio:"9/16" },
  { key:"banner",   label:"Banner (16:9)",  ratio:"16/9" },
  { key:"square",   label:"Square (1:1)",   ratio:"1/1" },
];

export const INIT_KURTI_STYLE_TILES = [
  { id:1, name:"Anarkali",     img:"https://images.unsplash.com/photo-1631166604827-8f3b6f5f5a8f?w=300&q=80", from:"₹1,299" },
  { id:2, name:"Printed",      img:"https://images.unsplash.com/photo-1583391733956-6c78276477e2?w=300&q=80", from:"₹999" },
  { id:3, name:"Straight Cut", img:"https://images.unsplash.com/photo-1594938298603-c8148c4b4d25?w=300&q=80", from:"₹899" },
  { id:4, name:"With Palazzo", img:"https://images.unsplash.com/photo-1576185850227-1f72b7f8d483?w=300&q=80", from:"₹1,499" },
  { id:5, name:"Embroidered",  img:"https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=300&q=80", from:"₹1,799" },
  { id:6, name:"A-Line",       img:"https://images.unsplash.com/photo-1583391733956-6c78276477e2?w=300&q=80&sat=-20", from:"₹1,099" },
];

export const INIT_OCCASION_TILES = [
  { id:1, title:"Office Wear",  category:"Kurti",       img:"https://images.unsplash.com/photo-1594938298603-c8148c4b4d25?w=500&q=80", active:true },
  { id:2, title:"Festive Edit", category:"3 Piece Set",  img:"https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=500&q=80", active:true },
];

export const INIT_CAT_STRIP = [
  { id:1, name:"Kurtis",      category:"Kurti",            img:"https://images.unsplash.com/photo-1583391733956-6c78276477e2?w=200&q=80", active:true },
  { id:2, name:"Anarkali",    category:"Kurti",            img:"https://images.unsplash.com/photo-1631166604827-8f3b6f5f5a8f?w=200&q=80", active:true },
  { id:3, name:"Cord Sets",   category:"Cord Set",         img:"https://images.unsplash.com/photo-1594938298603-c8148c4b4d25?w=200&q=80", active:true },
  { id:4, name:"3 Piece Sets",category:"3 Piece Set",      img:"https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=200&q=80", active:true },
  { id:5, name:"Western",     category:"Western Wear",     img:"https://images.unsplash.com/photo-1469334031218-e382a71b716b?w=200&q=80", active:true },
  { id:6, name:"Palazzo",     category:"Bottom Wear",      img:"https://images.unsplash.com/photo-1591369822096-ffd140ec948f?w=200&q=80", active:true },
  { id:7, name:"Blouse",      category:"Readymade Blouse", img:"https://images.unsplash.com/photo-1617019114583-affb34d1b3cd?w=200&q=80", active:true },
  { id:8, name:"Dupatta",     category:"Dupatta",          img:"https://images.unsplash.com/photo-1605763240000-7e93b172d754?w=200&q=80", active:true },
  { id:9, name:"Fabrics",     category:"Fabric",           img:"https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=200&q=80",    active:true },
  { id:10,name:"Bottom Wear", category:"Bottom Wear",      img:"https://images.unsplash.com/photo-1576185850227-1f72b7f8d483?w=200&q=80", active:true },
];

// ─── LOCAL STORAGE HELPERS ───────────────────────────────────────────────────
function load(key, fallback) {
  try { const v = localStorage.getItem(key); return v ? JSON.parse(v) : fallback; }
  catch(e) { return fallback; }
}
function save(key, val) {
  try { localStorage.setItem(key, JSON.stringify(val)); } catch(e) {}
}

// ─── CART REDUCER ────────────────────────────────────────────────────────────
function cartReducer(state, action) {
  switch(action.type) {
    case "ADD": {
      const k = `${action.p.id}-${action.p.sc}-${action.p.ss}`;
      const ex = state.find(i=>i.k===k);
      if(ex) return state.map(i=>i.k===k?{...i,qty:i.qty+1}:i);
      return [...state,{...action.p,k,qty:1}];
    }
    case "REM": return state.filter(i=>i.k!==action.k);
    case "QTY": return state.map(i=>i.k===action.k?{...i,qty:Math.max(1,i.qty+action.d)}:i);
    case "CLR": return [];
    case "MERGE": {
      let next = [...state];
      (action.items||[]).forEach(item => {
        const ex = next.find(i=>i.k===item.k);
        next = ex ? next.map(i=>i.k===item.k?{...i,qty:i.qty+item.qty}:i) : [...next, item];
      });
      return next;
    }
    default: return state;
  }
}

// ─── CONTEXT ─────────────────────────────────────────────────────────────────
export const Store = createContext();

// Maps a Supabase auth user into the {name,email,phone} shape the rest of the app expects
function mapAuthUser(su) {
  if (!su) return null;
  return {
    name:  su.user_metadata?.name || su.email?.split("@")[0] || "Customer",
    email: su.email,
    phone: su.user_metadata?.phone || "",
    addresses: su.user_metadata?.addresses || [],
    syncedCart: su.user_metadata?.cart || null,
    syncedWish: su.user_metadata?.wish || null,
  };
}

export function StoreProvider({children}) {
  const [cart, dispatch]       = useReducer(cartReducer, load("mw_cart", []));
  const [wish, setWish]        = useState(load("mw_wish", []));
  const [user, setUser]        = useState(null); // populated from Supabase session below
  const [authLoading, setAuthLoading] = useState(true);
  const [admin, setAdmin]      = useState(null); // populated by routeSession() below
  const [orders, setOrders]    = useState(load("mw_orders", []));
  const [products, setProducts]= useState(INIT_PRODUCTS);
  const [banners, setBanners]  = useState(INIT_BANNERS);
  const [catStrip, setCatStrip]= useState(INIT_CAT_STRIP);
  const [occasionTiles, setOccasionTiles] = useState(load("mw_occasion_tiles", INIT_OCCASION_TILES));
  const [sectionVis, setSectionVis] = useState(load("mw_section_vis", INIT_SECTION_VIS));
  const [kurtiStyleTiles, setKurtiStyleTiles] = useState(load("mw_kurti_style_tiles", INIT_KURTI_STYLE_TILES));
  const [heroPhotoDesktop, setHeroPhotoDesktop] = useState(load("mw_hero_photo_desktop", ""));
  const [heroPhotoMobile, setHeroPhotoMobile] = useState(load("mw_hero_photo_mobile", ""));
  const [logoUrl, setLogoUrl] = useState(load("mw_logo_url", "https://res.cloudinary.com/dsuzh8nfz/image/upload/v1780734289/WhatsApp_Image_2026-06-06_at_1.46.03_PM_aahhsu.jpg"));
  const [adminWhatsApp, setAdminWhatsApp] = useState(load("mw_admin_whatsapp", WA));
  const [freeShipThreshold, setFreeShipThreshold] = useState(load("mw_free_ship_threshold", 999));
  const [shippingFee, setShippingFee] = useState(load("mw_shipping_fee", 49));
  const [videoShowcases, setVideoShowcases] = useState(load("mw_video_showcases", []));
  const [categories, setCategories] = useState(load("mw_categories", CATEGORIES));
  const [catMetaExtra, setCatMetaExtra] = useState(load("mw_cat_meta_extra", {}));
  const [coupons, setCoupons] = useState(load("mw_coupons", INIT_COUPONS));
  const [announcements, setAnnouncements] = useState(load("mw_announcements", [
    "Free Delivery Above ₹999","Easy 7-Day Returns","100% Authentic","WhatsApp Support","New Arrivals Daily","Est. 1979 Chh. Sambhajinagar"
  ]));
  const [catPhotos, setCatPhotos] = useState(
    load("mw_catphotos", Object.fromEntries(CATEGORIES.map(c=>[c, INIT_CAT_STRIP.find(x=>x.category===c)?.img||""])))
  );
  const [reviews, setReviews]       = useState(load("mw_reviews", {}));
  const [productQA, setProductQA]   = useState(load("mw_product_qa", {}));
  const [recentViewed, setRecentViewed] = useState(load("mw_recent", []));
  const [featuredIds, setFeaturedIds]   = useState(load("mw_featured", [1,2,5,11]));
  const [homeCollections, setHomeCollections] = useState(load("mw_home_collections", []));
  const [dbReady, setDbReady] = useState(false);
  const [toast, setToast] = useState(null);

  // Coupon applied to the current cart (persists across refresh until removed/order placed)
  const [appliedCoupon, setAppliedCoupon] = useState(load("mw_coupon", null));

  // ─── LOAD FROM SUPABASE (products / banners / settings) ─────────────────────
  useEffect(()=>{
    async function loadFromDB() {
      try {
        // Load products
        const { data: prods } = await supabase.from("products").select("*");
        if (prods && prods.length > 0) {
          setProducts(prods.map(p=>({...p, desc:p.description})));
        } else {
          // First time — seed products to Supabase
          const toInsert = INIT_PRODUCTS.map(p=>({
            id:p.id, name:p.name, category:p.category, price:p.price, mrp:p.mrp,
            stock:p.stock, badge:p.badge||"", description:p.description||p.desc||"",
            material:p.material||"", care:p.care||"",
            colors:p.colors, sizes:p.sizes, img:p.img||"",
            images:p.images||(p.img?[p.img]:[]),
            colorImages:p.colorImages||{},
            sizeStock:p.sizeStock||{},
            rating:p.rating||4.5, reviews:p.reviews||0
          }));
          await supabase.from("products").upsert(toInsert);
          setProducts(INIT_PRODUCTS);
        }

        // Load banners
        const { data: bans } = await supabase.from("banners").select("*").order("sort_order");
        if (bans && bans.length > 0) setBanners(bans);
        else {
          await supabase.from("banners").upsert(INIT_BANNERS.map((b,i)=>({...b,sort_order:i})));
        }

        // Load settings
        const { data: settings } = await supabase.from("settings").select("*");
        if (settings) {
          const cs = settings.find(s=>s.key==="catStrip");
          const cp = settings.find(s=>s.key==="catPhotos");
          const fi = settings.find(s=>s.key==="featuredIds");
          const hc = settings.find(s=>s.key==="homeCollections");
          const ot = settings.find(s=>s.key==="occasionTiles");
          const sv = settings.find(s=>s.key==="sectionVis");
          const kt = settings.find(s=>s.key==="kurtiStyleTiles");
          const catg = settings.find(s=>s.key==="categories");
          const cme = settings.find(s=>s.key==="catMetaExtra");
          const cpn = settings.find(s=>s.key==="coupons");
          const ann = settings.find(s=>s.key==="announcements");
          const qa = settings.find(s=>s.key==="productQA");
          const hpd = settings.find(s=>s.key==="heroPhotoDesktop");
          const hpm = settings.find(s=>s.key==="heroPhotoMobile");
          const lu = settings.find(s=>s.key==="logoUrl");
          const awa = settings.find(s=>s.key==="adminWhatsApp");
          const vsc = settings.find(s=>s.key==="videoShowcases");
          const fst = settings.find(s=>s.key==="freeShipThreshold");
          const shf = settings.find(s=>s.key==="shippingFee");
          if (ot) setOccasionTiles(ot.value);
          if (sv) setSectionVis(v=>({...INIT_SECTION_VIS, ...sv.value}));
          if (kt) setKurtiStyleTiles(kt.value);
          if (catg) setCategories(catg.value);
          if (cme) setCatMetaExtra(cme.value);
          if (qa) setProductQA(qa.value);
          if (hpd) setHeroPhotoDesktop(hpd.value);
          if (hpm) setHeroPhotoMobile(hpm.value);
          if (lu) setLogoUrl(lu.value);
          if (awa) setAdminWhatsApp(awa.value);
          if (vsc) setVideoShowcases(vsc.value);
          if (fst) setFreeShipThreshold(fst.value);
          if (shf) setShippingFee(shf.value);
          if (cpn) setCoupons(cpn.value);
          if (ann) setAnnouncements(ann.value);
          if (cs) setCatStrip(cs.value);
          if (cp) setCatPhotos(cp.value);
          if (fi) setFeaturedIds(fi.value);
          if (hc) {
            setHomeCollections(hc.value);
          } else {
            // First run — seed the collections that used to be hardcoded, so
            // the homepage looks the same as before but is now editable.
            const srcProducts = (prods && prods.length > 0) ? prods : INIT_PRODUCTS;
            const seeded = [
              { id:0, title:"New In",        active:true, accent:"#EC4899", style:"newin", productIds: srcProducts.filter(p=>p.stock>0).slice(0,8).map(p=>p.id) },
              { id:5, title:"Trendy",         active:true, accent:"#7C3AED", style:"trendy",productIds: srcProducts.filter(p=>p.stock>0).sort((a,b)=>(b.reviews||0)-(a.reviews||0)).slice(0,8).map(p=>p.id) },
              { id:1, title:"Fresh Picks",   active:true, accent:"#EC4899", style:"wave",  productIds: srcProducts.filter(p=>p.badge==="New"||p.badge==="Hot").map(p=>p.id) },
              { id:2, title:"Trending Now",   active:true, accent:"#7C3AED", style:"strip", productIds: srcProducts.filter(p=>p.badge==="Trending"||p.badge==="Bestseller").map(p=>p.id) },
              { id:3, title:"Premium Picks",  active:true, accent:"#F59E0B", style:"tag",   productIds: srcProducts.filter(p=>p.badge==="Premium").map(p=>p.id) },
              { id:4, title:"Under ₹999",    active:true, accent:"#10B981", style:"grid",  productIds: srcProducts.filter(p=>p.price<999).map(p=>p.id) },
            ];
            setHomeCollections(seeded);
            await saveSetting("homeCollections", seeded);
          }
        }

        setDbReady(true);
      } catch(e) {
        console.log("DB load error:", e);
        setDbReady(true);
      }
    }
    loadFromDB();
  }, []);

  // ─── AUTH — real Supabase Auth session (replaces localStorage passwords) ────
  // One Supabase Auth session serves both roles: a session whose user_metadata
  // has role:"admin" is treated as an admin session (see deploy notes for how
  // to tag the two admin accounts); everyone else is a regular customer.
  useEffect(()=>{
    supabase.auth.getSession().then(({data}) => {
      routeSession(data?.session);
      setAuthLoading(false);
    });
    const { data: sub } = supabase.auth.onAuthStateChange((_event, session) => {
      routeSession(session);
    });
    return () => sub.subscription.unsubscribe();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  function routeSession(session) {
    const su = session?.user;
    if (su?.user_metadata?.role === "admin") {
      setAdmin({ name: su.user_metadata?.name || "Admin", email: su.email, role:"admin" });
      setUser(null);
    } else {
      setAdmin(null);
      const mapped = mapAuthUser(su);
      setUser(mapped);
      // One-time merge when logging in — combine what's saved on the account
      // (from another device) with whatever's already in this browser's cart/wishlist.
      if (mapped?.syncedCart?.length) dispatch({ type:"MERGE", items: mapped.syncedCart });
      if (mapped?.syncedWish?.length) setWish(w => [...new Set([...w, ...mapped.syncedWish])]);
    }
  }

  const signUp = async (name, email, phone, password) => {
    if (!name || !email || !password) { notify("Sab fields bharo", "err"); return false; }
    if (password.length < 6) { notify("Password kam se kam 6 characters ka hona chahiye", "err"); return false; }
    const { data, error } = await supabase.auth.signUp({
      email, password,
      options: { data: { name, phone } },
    });
    if (error) { notify(error.message, "err"); return false; }
    if (data.session) {
      notify("Account ban gaya! Welcome, " + name + "!");
    } else {
      // Email confirmation is turned on for this project — tell the user what to do
      notify("Account ban gaya! Apna email confirm karke login karo.", "ok");
    }
    saveToSheet({ type:"customer", name, email, phone, source:"Registration" });
    return true;
  };

  const signIn = async (email, password) => {
    if (!email || !password) { notify("Email aur password required", "err"); return false; }
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) { notify("Invalid email ya password!", "err"); return false; }
    notify("Welcome back!");
    return true;
  };

  const signInAdmin = async (email, password) => {
    if (!email || !password) { notify("Email aur password required", "err"); return false; }
    const { data, error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) { notify("Invalid credentials", "err"); return false; }
    if (data.session?.user?.user_metadata?.role !== "admin") {
      await supabase.auth.signOut();
      notify("Ye account admin nahi hai", "err");
      return false;
    }
    notify(`Welcome, ${data.session.user.user_metadata?.name || "Admin"}!`);
    return true;
  };

  const signOutUser = async () => {
    await supabase.auth.signOut();
    notify("Logged out");
  };

  const getAccessToken = async () => {
    const { data } = await supabase.auth.getSession();
    return data?.session?.access_token || null;
  };

  // ─── LOAD ORDERS (separately — scoped by who's logged in) ───────────────────
  // Admin sees every order. A logged-in customer sees ONLY their own orders
  // (matched by the email they placed the order with). A guest sees nothing
  // from the server — only whatever is cached locally on this device.
  useEffect(()=>{
    async function loadOrders() {
      try {
        if (admin) {
          const { data } = await supabase.from("orders").select("*").order("created_at", {ascending:false});
          if (data) setOrders(data);
        } else if (user?.email) {
          const { data } = await supabase.from("orders").select("*")
            .eq("customer_email", user.email)
            .order("created_at", {ascending:false});
          if (data) setOrders(data);
        } else {
          // Guest / logged out — don't pull anyone else's orders from the server
          setOrders(load("mw_orders", []));
        }
      } catch(e) {
        console.log("Orders load error:", e);
      }
    }
    loadOrders();
  }, [admin, user?.email]);

  // ─── SAVE TO SUPABASE ────────────────────────────────────────────────────────
  const saveProduct = async (p) => {
    await supabase.from("products").upsert({
      id:p.id, name:p.name, category:p.category, price:p.price, mrp:p.mrp,
      stock:p.stock, badge:p.badge||"", description:p.description||p.desc||"",
      material:p.material||"", care:p.care||"",
      colors:p.colors, sizes:p.sizes, img:p.img||"",
      images:p.images||[],
      colorImages:p.colorImages||{},
      sizeStock:p.sizeStock||{},
      rating:p.rating||4.5, reviews:p.reviews||0
    });
  };

  const deleteProduct = async (id) => {
    await supabase.from("products").delete().eq("id", id);
  };

  // NOTE: order creation no longer happens client-side (removed saveOrderToDB) —
  // orders are now written exclusively by the verify-razorpay-payment Edge
  // Function using the service role key. See recordServerOrder below.

  const updateOrderStatus = async (id, status) => {
    await supabase.from("orders").update({status}).eq("id", id);
  };

  const saveSetting = async (key, value) => {
    await supabase.from("settings").upsert({key, value});
  };

  // ─── LOCAL STORAGE SAVES ────────────────────────────────────────────────────
  useEffect(()=>save("mw_cart", cart), [cart]);

  // Keep the logged-in customer's account copy of cart/wish up to date too,
  // so it's there waiting on their next device. Debounced so we don't hit
  // Supabase on every single click.
  useEffect(() => {
    if (!user) return;
    const t = setTimeout(() => {
      supabase.auth.updateUser({ data: { name:user.name, phone:user.phone, addresses:user.addresses||[], cart, wish } });
    }, 1500);
    return () => clearTimeout(t);
  }, [cart, wish, user?.email]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(()=>save("mw_wish", wish), [wish]);
  useEffect(()=>save("mw_orders", orders), [orders]);
  useEffect(()=>save("mw_catphotos", catPhotos), [catPhotos]);
  useEffect(()=>save("mw_reviews", reviews), [reviews]);
  useEffect(()=>save("mw_recent", recentViewed), [recentViewed]);
  useEffect(()=>save("mw_featured", featuredIds), [featuredIds]);
  useEffect(()=>save("mw_home_collections", homeCollections), [homeCollections]);
  useEffect(()=>save("mw_occasion_tiles", occasionTiles), [occasionTiles]);
  useEffect(()=>save("mw_section_vis", sectionVis), [sectionVis]);
  useEffect(()=>save("mw_kurti_style_tiles", kurtiStyleTiles), [kurtiStyleTiles]);
  useEffect(()=>save("mw_categories", categories), [categories]);
  useEffect(()=>save("mw_cat_meta_extra", catMetaExtra), [catMetaExtra]);
  useEffect(()=>save("mw_coupons", coupons), [coupons]);
  useEffect(()=>save("mw_announcements", announcements), [announcements]);
  useEffect(()=>save("mw_product_qa", productQA), [productQA]);
  useEffect(()=>save("mw_hero_photo_desktop", heroPhotoDesktop), [heroPhotoDesktop]);
  useEffect(()=>save("mw_hero_photo_mobile", heroPhotoMobile), [heroPhotoMobile]);
  useEffect(()=>save("mw_logo_url", logoUrl), [logoUrl]);
  useEffect(()=>save("mw_admin_whatsapp", adminWhatsApp), [adminWhatsApp]);
  useEffect(()=>save("mw_free_ship_threshold", freeShipThreshold), [freeShipThreshold]);
  useEffect(()=>save("mw_shipping_fee", shippingFee), [shippingFee]);
  useEffect(()=>save("mw_video_showcases", videoShowcases), [videoShowcases]);
  useEffect(()=>save("mw_coupon", appliedCoupon), [appliedCoupon]);

  const notify = useCallback((msg, type="ok") => {
    setToast({msg,type});
    setTimeout(()=>setToast(null), 3000);
  }, []);

  const toggleWish = id => setWish(w=>w.includes(id)?w.filter(x=>x!==id):[...w,id]);
  const addReview = (pid, review) => setReviews(r=>({...r,[pid]:[review,...(r[pid]||[])]}));
  const addRecentViewed = useCallback((pid)=>{
    setRecentViewed(r=>[pid,...r.filter(x=>x!==pid)].slice(0,10));
  },[]);

  const cartQty   = cart.reduce((s,i)=>s+i.qty, 0);
  const cartTotal = cart.reduce((s,i)=>s+i.price*i.qty, 0);

  // ─── COUPONS ──────────────────────────────────────────────────────────────
  const computeDiscount = useCallback((coupon, subtotal) => {
    if (!coupon) return 0;
    const def = coupons[coupon];
    if (!def || def.active===false) return 0;
    if (subtotal < def.minOrder) return 0;
    let d = def.type === "percent" ? Math.round(subtotal * def.value / 100) : def.value;
    if (def.maxDiscount) d = Math.min(d, def.maxDiscount);
    return Math.min(d, subtotal);
  }, [coupons]);

  const discount = computeDiscount(appliedCoupon, cartTotal);

  const applyCoupon = (codeRaw) => {
    const code = (codeRaw||"").trim().toUpperCase();
    const def = coupons[code];
    if (!def || def.active===false) { notify("Invalid coupon code", "err"); return false; }
    if (cartTotal < def.minOrder) { notify(`Minimum order ₹${def.minOrder} for this coupon`, "err"); return false; }
    setAppliedCoupon(code);
    notify(`Coupon applied — ${def.label}!`);
    return true;
  };

  const removeCoupon = () => setAppliedCoupon(null);

  // Reduce (or restore) stock for the items in an order — keeps both the
  // overall `stock` number and per-size `sizeStock` in sync, and never goes
  // below zero. direction: -1 when an order is placed, +1 when it's cancelled.
  const adjustStock = async (items, direction) => {
    const updated = products.map(p => {
      const relevant = items.filter(i => i.id === p.id);
      if (!relevant.length) return p;
      const hasSizeStock = p.sizeStock && Object.keys(p.sizeStock).length > 0;
      const newSizeStock = hasSizeStock ? { ...p.sizeStock } : null;
      let newStock = p.stock;
      relevant.forEach(i => {
        const qty = i.qty || 1;
        if (newSizeStock && i.ss != null && newSizeStock[i.ss] !== undefined) {
          newSizeStock[i.ss] = Math.max(0, newSizeStock[i.ss] + direction*qty);
        }
        newStock = Math.max(0, newStock + direction*qty);
      });
      return { ...p, stock:newStock, ...(newSizeStock ? { sizeStock:newSizeStock } : {}) };
    });
    await setProductsWithDB(updated);
  };

  // Called after the verify-razorpay-payment Edge Function has already
  // securely created the order + decremented stock server-side. This just
  // reflects that result in local state — no direct DB writes happen here
  // anymore (that's the whole point: RLS no longer needs to trust the
  // browser to write orders or touch stock).
  const recordServerOrder = (order) => {
    const o = { ...order, couponCode: order.coupon_code };
    setOrders(prev=>[o,...prev]);
    dispatch({type:"CLR"});
    setAppliedCoupon(null);
    saveToSheet({ type:"order", orderId:o.id, items:o.items, total:o.total, discount:o.discount, couponCode:o.couponCode, addr:o.addr, pay:o.pay, status:"Confirmed" });

    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "purchase", {
        transaction_id: o.id,
        value: o.total,
        currency: "INR",
        coupon: o.couponCode || undefined,
        items: o.items.map(i => ({
          item_id: String(i.id), item_name: i.name, item_category: i.category,
          price: i.price, quantity: i.qty,
        })),
      });
    }
    return o;
  };

  // Enhanced setProducts that also saves to Supabase
  const setProductsWithDB = async (fn) => {
    const newProducts = typeof fn === "function" ? fn(products) : fn;
    setProducts(newProducts);
    // Find changed/new products and save them
    for (const p of newProducts) {
      const old = products.find(x=>x.id===p.id);
      if (!old || JSON.stringify(old) !== JSON.stringify(p)) {
        await saveProduct(p);
      }
    }
    // Find deleted products
    for (const p of products) {
      if (!newProducts.find(x=>x.id===p.id)) {
        await deleteProduct(p.id);
      }
    }
  };

  // Status-specific WhatsApp message to the customer. Edit the wording here
  // any time — this is the single place that controls what gets pre-filled.
  const statusWaMessage = (o) => {
    const name = o.addr?.name || "there";
    switch (o.status) {
      case "Confirmed":
        return `Hi ${name}! 🎉 Aapka Matchwell order *${o.id}* confirm ho gaya hai.\nTotal: ₹${o.total?.toLocaleString("en-IN")}\nExpected delivery: ${o.eta}\n\nShopping karne ke liye shukriya!`;
      case "Packed":
        return `Hi ${name}! 📦 Aapka order *${o.id}* pack ho gaya hai aur jaldi hi ship hoga. Expected delivery: ${o.eta}`;
      case "Shipped":
        return `Hi ${name}! 🚚 Good news — aapka order *${o.id}* ship ho gaya hai! Expected delivery: ${o.eta}`;
      case "Delivered":
        return `Hi ${name}! ✅ Aapka order *${o.id}* deliver ho gaya. Umeed hai aapko pasand aaya — Matchwell se shopping karne ke liye shukriya! 🙏`;
      default:
        return `Hi ${name}! Aapke order *${o.id}* ka status update hua hai: ${o.status}`;
    }
  };

  // Opens a WhatsApp Web/App tab addressed to the customer with the message
  // pre-filled. WhatsApp does not allow auto-sending without the paid
  // Business API, so this still needs one manual tap of the Send button.
  const notifyCustomerWhatsApp = (o) => {
    const phone = (o.addr?.phone || "").replace(/\D/g, "");
    if (!phone) return;
    const withCountryCode = phone.length === 10 ? `91${phone}` : phone;
    const url = `https://wa.me/${withCountryCode}?text=${encodeURIComponent(statusWaMessage(o))}`;
    const a = document.createElement("a");
    a.href = url;
    a.target = "_blank";
    a.rel = "noreferrer";
    a.click();
  };

  const setOrdersWithDB = (fn) => {
    const newOrders = typeof fn === "function" ? fn(orders) : fn;
    setOrders(newOrders);
    // Update status changes
    for (const o of newOrders) {
      const old = orders.find(x=>x.id===o.id);
      if (old && old.status !== o.status) {
        updateOrderStatus(o.id, o.status);
        if ((o.status === "Cancelled" || o.status === "Returned") && old.status !== "Cancelled" && old.status !== "Returned") {
          adjustStock(o.items, +1);
        }
        notifyCustomerWhatsApp(o);
        notify(`WhatsApp tab khula ${o.addr?.name || "customer"} ke liye — Send dabana na bhoolein`);
      }
    }
  };

  const setCatStripWithDB = (val) => {
    const v = typeof val === "function" ? val(catStrip) : val;
    setCatStrip(v);
    saveSetting("catStrip", v);
  };

  const setCatPhotosWithDB = (val) => {
    const v = typeof val === "function" ? val(catPhotos) : val;
    setCatPhotos(v);
    saveSetting("catPhotos", v);
  };

  const setFeaturedIdsWithDB = (val) => {
    const v = typeof val === "function" ? val(featuredIds) : val;
    setFeaturedIds(v);
    saveSetting("featuredIds", v);
  };

  const setHomeCollectionsWithDB = (val) => {
    const v = typeof val === "function" ? val(homeCollections) : val;
    setHomeCollections(v);
    saveSetting("homeCollections", v);
  };

  const setOccasionTilesWithDB = (val) => {
    const v = typeof val === "function" ? val(occasionTiles) : val;
    setOccasionTiles(v);
    saveSetting("occasionTiles", v);
  };

  const setSectionVisWithDB = (val) => {
    const v = typeof val === "function" ? val(sectionVis) : val;
    setSectionVis(v);
    saveSetting("sectionVis", v);
  };

  const setKurtiStyleTilesWithDB = (val) => {
    const v = typeof val === "function" ? val(kurtiStyleTiles) : val;
    setKurtiStyleTiles(v);
    saveSetting("kurtiStyleTiles", v);
  };

  const setCategoriesWithDB = (val) => {
    const v = typeof val === "function" ? val(categories) : val;
    setCategories(v);
    saveSetting("categories", v);
  };

  const setCatMetaExtraWithDB = (val) => {
    const v = typeof val === "function" ? val(catMetaExtra) : val;
    setCatMetaExtra(v);
    saveSetting("catMetaExtra", v);
  };

  const setCouponsWithDB = (val) => {
    const v = typeof val === "function" ? val(coupons) : val;
    setCoupons(v);
    saveSetting("coupons", v);
  };

  const setAnnouncementsWithDB = (val) => {
    const v = typeof val === "function" ? val(announcements) : val;
    setAnnouncements(v);
    saveSetting("announcements", v);
  };

  const setHeroPhotoDesktopWithDB = (val) => { setHeroPhotoDesktop(val); saveSetting("heroPhotoDesktop", val); };
  const setHeroPhotoMobileWithDB = (val) => { setHeroPhotoMobile(val); saveSetting("heroPhotoMobile", val); };
  const setLogoUrlWithDB = (val) => { setLogoUrl(val); saveSetting("logoUrl", val); };
  const setAdminWhatsAppWithDB = (val) => {
    const digits = String(val||"").replace(/\D/g,"");
    setAdminWhatsApp(digits);
    saveSetting("adminWhatsApp", digits);
  };

  const setFreeShipThresholdWithDB = (val) => { const n = Math.max(0, Number(val)||0); setFreeShipThreshold(n); saveSetting("freeShipThreshold", n); };
  const setShippingFeeWithDB = (val) => { const n = Math.max(0, Number(val)||0); setShippingFee(n); saveSetting("shippingFee", n); };

  const setVideoShowcasesWithDB = (val) => {
    const v = typeof val === "function" ? val(videoShowcases) : val;
    setVideoShowcases(v);
    saveSetting("videoShowcases", v);
  };

  const askQuestion = async (pid, question, askedBy) => {
    if (!question?.trim()) { notify("Sawal likho", "err"); return; }
    try {
      const res = await fetch("https://hmgeuxrzfvtmakzgpqub.supabase.co/functions/v1/ask-question", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ productId: pid, question, askedBy }),
      });
      const data = await res.json();
      if (!res.ok || !data.success) throw new Error(data.error || "Failed");
      setProductQA(data.productQA);
      notify("Sawal poocha gaya — jaldi jawab milega!");
    } catch (e) {
      notify("Sawal save nahi ho paya. Dobara try karein.", "err");
    }
  };

  const answerQuestion = (pid, qid, answer) => {
    if (!answer?.trim()) { notify("Jawab likho", "err"); return; }
    setProductQA(prev => {
      const updated = { ...prev, [pid]: (prev[pid]||[]).map(q => q.id===qid ? { ...q, answer: answer.trim(), answerDate: new Date().toLocaleDateString("en-IN") } : q) };
      saveSetting("productQA", updated);
      return updated;
    });
    notify("Jawab post ho gaya!");
  };

  // ─── SAVED ADDRESSES (stored on the customer's own Supabase Auth account) ───
  const saveAddress = async (addr) => {
    if (!user) { notify("Pehle login karo address save karne ke liye", "err"); return false; }
    const current = user.addresses || [];
    const updated = [...current, { ...addr, id: Date.now() }];
    const { error } = await supabase.auth.updateUser({ data: { addresses: updated } });
    if (error) { notify("Address save nahi hui", "err"); return false; }
    setUser(u => ({ ...u, addresses: updated }));
    notify("Address saved!");
    return true;
  };

  const deleteAddress = async (id) => {
    const updated = (user?.addresses||[]).filter(a=>a.id!==id);
    const { error } = await supabase.auth.updateUser({ data: { addresses: updated } });
    if (error) { notify("Delete nahi hui", "err"); return false; }
    setUser(u => ({ ...u, addresses: updated }));
    notify("Address removed");
    return true;
  };

  // ─── SELF-SERVICE ORDER CANCEL (customer side — before it's packed) ────────
  // Goes through a secure Edge Function now (verifies the caller really owns
  // this order via their login token, then restores stock server-side).
  const cancelOrder = async (orderId) => {
    const o = orders.find(x=>x.id===orderId);
    if (!o) return false;
    if (o.status !== "Confirmed") { notify("Ye order ab cancel nahi ho sakta — pack/ship ho chuka hai", "err"); return false; }
    try {
      const token = await getAccessToken();
      if (!token) { notify("Order cancel karne ke liye login karo", "err"); return false; }
      const res = await fetch("https://hmgeuxrzfvtmakzgpqub.supabase.co/functions/v1/cancel-order", {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ orderId }),
      });
      const data = await res.json();
      if (!res.ok || !data.success) { notify(data.error || "Order cancel nahi ho paya", "err"); return false; }
    } catch (e) {
      notify("Order cancel nahi ho paya", "err");
      return false;
    }
    setOrders(os => os.map(x => x.id===orderId ? {...x, status:"Cancelled"} : x));
    notify(o.pay !== "whatsapp" ? "Order cancel ho gaya — refund 5-7 din me aapke original payment method me aayega" : "Order cancel ho gaya");

    // Let the admin know a refund needs to be processed manually via Razorpay Dashboard
    if (o.pay !== "whatsapp") {
      const msg = `⚠️ *Order Cancelled — Refund Needed*\n\nOrder: ${o.id}\nCustomer: ${o.addr?.name}\nAmount: ₹${o.total}\nPayment: ${o.pay?.toUpperCase()}\n\nPlease process the refund from the Razorpay Dashboard.`;
      const a = document.createElement("a");
      a.href = `https://wa.me/${adminWhatsApp}?text=${encodeURIComponent(msg)}`;
      a.target = "_blank"; a.rel = "noreferrer";
      a.click();
    }
    return true;
  };

  const addCategory = (name, emoji, color) => {
    const clean = (name||"").trim();
    if (!clean) { notify("Category name likho", "err"); return false; }
    if (categories.includes(clean)) { notify("Ye category already hai", "err"); return false; }
    setCategoriesWithDB(cs=>[...cs, clean]);
    if (emoji || color) {
      setCatMetaExtraWithDB(m=>({...m, [clean]:{ emoji:emoji||"👗", color:color||"#EC4899", light:(color||"#EC4899")+"18" }}));
    }
    notify("Category add ho gayi!");
    return true;
  };

  const removeCategory = (name) => {
    const inUse = products.some(p=>p.category===name);
    if (inUse) { notify("Is category me products hain — pehle unhe move/delete karo", "err"); return false; }
    setCategoriesWithDB(cs=>cs.filter(c=>c!==name));
    setCatMetaExtraWithDB(m=>{ const n={...m}; delete n[name]; return n; });
    notify("Category delete ho gayi");
    return true;
  };

  return (
    <Store.Provider value={{
      cart, dispatch, wish, toggleWish,
      user, authLoading, signUp, signIn, signOut:signOutUser,
      admin, signInAdmin, getAccessToken,
      orders, setOrders:setOrdersWithDB, recordServerOrder,
      products, setProducts:setProductsWithDB,
      banners, setBanners,
      catStrip, setCatStrip:setCatStripWithDB,
      catPhotos, setCatPhotos:setCatPhotosWithDB,
      reviews, addReview,
      recentViewed, addRecentViewed,
      featuredIds, setFeaturedIds:setFeaturedIdsWithDB,
      homeCollections, setHomeCollections:setHomeCollectionsWithDB,
      occasionTiles, setOccasionTiles:setOccasionTilesWithDB,
      sectionVis, setSectionVis:setSectionVisWithDB,
      kurtiStyleTiles, setKurtiStyleTiles:setKurtiStyleTilesWithDB,
      categories, setCategories:setCategoriesWithDB, catMetaExtra, addCategory, removeCategory,
      coupons, setCoupons:setCouponsWithDB,
      announcements, setAnnouncements:setAnnouncementsWithDB,
      productQA, askQuestion, answerQuestion,
      heroPhotoDesktop, setHeroPhotoDesktop:setHeroPhotoDesktopWithDB,
      heroPhotoMobile, setHeroPhotoMobile:setHeroPhotoMobileWithDB,
      logoUrl, setLogoUrl:setLogoUrlWithDB,
      adminWhatsApp, setAdminWhatsApp:setAdminWhatsAppWithDB,
      freeShipThreshold, setFreeShipThreshold:setFreeShipThresholdWithDB,
      shippingFee, setShippingFee:setShippingFeeWithDB,
      videoShowcases, setVideoShowcases:setVideoShowcasesWithDB,
      saveAddress, deleteAddress, cancelOrder,
      cartQty, cartTotal, notify, dbReady,
      appliedCoupon, applyCoupon, removeCoupon, discount,
    }}>
      {children}
      {toast && (
        <div style={{position:"fixed",bottom:80,left:"50%",transform:"translateX(-50%)",background:toast.type==="err"?"#EF4444":"#1a1a2e",color:"white",padding:"12px 24px",borderRadius:8,fontSize:13,fontWeight:600,zIndex:99999,boxShadow:"0 8px 32px rgba(0,0,0,0.2)",whiteSpace:"nowrap"}}>
          {toast.type==="ok"?"✓ ":"⚠ "}{toast.msg}
        </div>
      )}
    </Store.Provider>
  );
}

export function useStore() { return useContext(Store); }
